
import request from '../utils/request'


//官网页面展示顶部轮播图
function selectByState(data){
    return request({
        url : '/banner/selectByState',
        method : 'POST',
        data
    });
}


export default {
    selectByState
}